import { CL_COUNTRY } from "@/apps/credit-line/types/cl_countries";
import {
  CO_FAQS,
  FaqsService,
  MX_FAQS,
} from "@/apps/credit-line/services/multi-country/faqs.service";

export const FaqsHelper = (country: CL_COUNTRY): FaqsService => {
  switch (country) {
    case CL_COUNTRY.CO:
      return new CO_FAQS();
    case CL_COUNTRY.MX:
    default:
      return new MX_FAQS();
  }
};
